/* CDX Pill-Tabs — gemeinsame Logik für Serie & Datenblatt ([data-serie-tabs]).
   Idempotent: mehrfaches Einbinden/Init schadet nicht. */
(function () {
  function init() {
    document.querySelectorAll('[data-serie-tabs]').forEach(function (root) {
      if (root.dataset.tabsReady) return;
      root.dataset.tabsReady = '1';
      var tabs = root.querySelectorAll('.serie-tab');
      var panels = root.querySelectorAll('.serie-panel');
      function act(n) {
        tabs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.tab === n); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === n); });
        document.dispatchEvent(new Event('cdx:slider-refresh'));
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { act(t.dataset.tab); }); });
      if (tabs[0]) act(tabs[0].dataset.tab);
    });
  }
  window.__cdxTabs = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
